import { alertQueue, AlertType, Flex } from "@connectme2/ui";
import { ErrorBasic, Success } from "@connectme2/ui/illustrations";
import { useCallback, useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import { DstnyForDevelopersIcon } from "../components/icons";
import { Loader } from "../components/lib/Loader/Loader";
import GlobalService from "../services/Service";

function ValidationPage() {
    const params = useParams();

    const initialized = useRef(false);
    const [state, setState] = useState<"success" | "error" | undefined>(undefined);
    const [errorMessage, setErrorMessage] = useState<string>("");
    const [services, setServices] = useState<any>(null);

    // Validate token
    const load = useCallback(async () => {
        // create instance here to avoid useCallback deps warning
        const RegisterService = (await import("../services/RegisterService")).default;
        const registerService = new RegisterService();

        const token = params.token;
        try {
            const result = await registerService.validate(token);
            console.log("validation result", result);
            setState("success");
            localStorage.setItem("onboarded", "true");
        } catch (e: any) {
            console.error(e);
            setState("error");
            // store the API error message to display in JSX
            setErrorMessage(e?.message || "Something went wrong");
        }
    }, [params.token]);

    // Get services from localStorage or API
    const getServices = useCallback(async () => {
        const storedServices = localStorage.getItem("services");
        if (storedServices) {
            const parsed = JSON.parse(storedServices);
            setServices(parsed);
            console.log("services loaded from localStorage:", parsed); // reference services to avoid unused warning
            return;
        }

        const globalService = new GlobalService();
        try {
            const result = await globalService.services();
            setServices(result);
            console.log("services loaded from API:", result);
        } catch (error: any) {
            console.error(error);
            alertQueue.add({
                type: AlertType.error,
                title: "Error to get services",
                description: error?.toString(),
                hasClose: true,
            });
        }
    }, [setServices]);

    useEffect(() => {
        if (initialized.current) {
            return;
        }
        initialized.current = true;
        (async () => {
            await getServices();
            await load();
        })();
    }, [getServices, load]);

    // Redirect after success
    useEffect(() => {
        (async () => {
            if (state === "success" && services?.console_url) {
                const timer = setTimeout(() => {
                    window.location.href = services.console_url;
                }, 3500)

                return () => clearTimeout(timer)
            }
        })()
    }, [state, services])

    return <div className="app-register">
        <Flex direction="column" alignItems="center" gap="xl">
            <DstnyForDevelopersIcon />
            {state === undefined ?
                <Loader /> :
                (state === "success" ?
                    <>
                        <Success />
                        <h2>Congratulations 🎉</h2>
                        <p>
                            You’ve unlocked the rank of Destiny Developer. <br />
                            You’ll be warped to the console in just a few seconds...
                        </p>
                    </> :
                    <>
                        <ErrorBasic />
                        <p>Something has gone wrong during your onboarding process.</p>
                        <p>{errorMessage}</p>
                    </>)

            }
        </Flex>
    </div>
}

export default ValidationPage;
